import React from 'react';

const Share = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M23.6 9.2L15.2.8c-.2-.2-.5-.2-.7-.1-.2.1-.4.4-.4.6v4.9C.2 6.7 0 22.9 0 23.1c0 .4.3.7.6.7h.1c.3 0 .6-.2.7-.6.1-.4 2.1-9.6 12.7-10v4.9c0 .3.2.5.4.6.2.1.5.1.7-.1l8.4-8.4c.2-.1.3-.3.3-.5s-.1-.4-.3-.5z" />
  </svg>
);

export default Share;
